<ng-container *ngIf="(sidebar.isMobileView$ | async)">
  <div *ngIf="(sidebar.isOpen$ | async)" class="fixed inset-0 bg-black/40 z-[998]" (click)="sidebar.close()">
  </div>
</ng-container>

<div class="fixed left-0 top-0 z-[999] h-screen w-[278px] bg-white text-black shadow-lg border-r border-gray-200 flex flex-col
         transition-transform duration-300 will-change-transform
         lg:translate-x-0" [class.-translate-x-full]="(sidebar.isMobileView$ | async) && !(sidebar.isOpen$ | async)"
  [class.translate-x-0]="(sidebar.isMobileView$ | async) && (sidebar.isOpen$ | async)">

  <div class="py-4 px-6 mt-8 shrink-0">
    <a routerLink="/dashboard">
      <img src="./assets/logo-en-white.svg" alt="" class="h-12">
    </a>
  </div>

  <div class="flex-1 overflow-y-auto pt-12 pb-6 pr-1 overscroll-contain">
    <ul class="space-y-3">
      <ng-container *ngFor="let item of menuItems">
        <li>
          <a *ngIf="!item.subItems" class="flex items-center px-6 py-2 hover:bg-gray-100 transition-colors duration-200"
            [routerLink]="item.route"
            [ngClass]="{'bg-[#ECFFF5] text-[#0DAC57] border-r-[2px] border-[#0DAC57]': isActiveRoute(item.route)}">
            <i class="{{item.icon}} mr-3"></i>
            <span>{{item.label}}</span>
          </a>

          <div *ngIf="item.subItems" class="cursor-pointer">
            <div class="flex items-center justify-between px-6 py-2 hover:bg-gray-100 transition-colors duration-200"
              [ngClass]="{'bg-[#ECFFF5] text-[#0DAC57] border-r-[2px] border-[#0DAC57]': isActiveRoute(item.route)}"
              (click)="toggleSubMenu(item.label)">
              <div class="flex items-center">
                <i class="{{item.icon}} mr-3"></i>
                <span>{{item.label}}</span>
              </div>
              <i class="pi pi-angle-down transition-transform duration-200"
                [ngClass]="{'rotate-180': activeItem === item.label}"></i>
            </div>

            <ul *ngIf="activeItem === item.label">
              <li *ngFor="let subItem of item.subItems">
                <a class="flex items-center text-sm px-6 py-2 hover:bg-gray-100 transition-colors duration-200"
                  [routerLink]="subItem.route"
                  [ngClass]="{'text-[#0DAC57] font-medium': isActiveRoute(subItem.route)}">
                  {{subItem.label}}
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
